import React from 'react';
import { motion } from 'framer-motion';
export function Features() {
  return <section id="features" className="py-24 border-b border-stone-300" data-id="element-1337">
      <div className="max-w-6xl mx-auto px-6" data-id="element-1338">
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-1339">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-16" data-id="element-1340">
            {/* Left: Header */}
            <div className="lg:col-span-4" data-id="element-1341">
              <p className="font-mono text-xs uppercase tracking-widest text-stone-500 mb-6" data-id="element-1342">
                Platform
              </p>

              <h2 className="font-serif text-4xl tracking-tight leading-[1.1] text-stone-900 mb-6" data-id="element-1343">
                Everything you need to quote, hold, and close
              </h2>

              <p className="text-lg text-stone-600 leading-relaxed" data-id="element-1344">
                A complete operating system for group travel distribution. Built
                for revenue teams who need control.
              </p>
            </div>

            {/* Right: Feature list */}
            <div className="lg:col-span-8" data-id="element-1345">
              <div className="border-t border-stone-300" data-id="element-1346">
                <div className="py-6 border-b border-stone-300 grid grid-cols-12 gap-4" data-id="element-1347">
                  <div className="col-span-1" data-id="element-1348">
                    <span className="font-mono text-xs text-stone-400" data-id="element-1349">01</span>
                  </div>
                  <div className="col-span-4" data-id="element-1350">
                    <p className="font-medium text-stone-900" data-id="element-1351">
                      Multi-Property Quotes
                    </p>
                  </div>
                  <div className="col-span-7" data-id="element-1352">
                    <p className="text-stone-600" data-id="element-1353">
                      Instant quotes across your entire portfolio. Room blocks,
                      dates, occupancy, event needs—handled in seconds.
                    </p>
                  </div>
                </div>

                <div className="py-6 border-b border-stone-300 grid grid-cols-12 gap-4" data-id="element-1354">
                  <div className="col-span-1" data-id="element-1355">
                    <span className="font-mono text-xs text-stone-400" data-id="element-1356">02</span>
                  </div>
                  <div className="col-span-4" data-id="element-1357">
                    <p className="font-medium text-stone-900" data-id="element-1358">Smart Holds</p>
                  </div>
                  <div className="col-span-7" data-id="element-1359">
                    <p className="text-stone-600" data-id="element-1360">
                      Automated hold timers with expiry management. Inventory
                      secured, no manual follow-ups required.
                    </p>
                  </div>
                </div>

                <div className="py-6 border-b border-stone-300 grid grid-cols-12 gap-4" data-id="element-1361">
                  <div className="col-span-1" data-id="element-1362">
                    <span className="font-mono text-xs text-stone-400" data-id="element-1363">03</span>
                  </div>
                  <div className="col-span-4" data-id="element-1364">
                    <p className="font-medium text-stone-900" data-id="element-1365">
                      Package Builder
                    </p>
                  </div>
                  <div className="col-span-7" data-id="element-1366">
                    <p className="text-stone-600" data-id="element-1367">
                      Good / Better / Best options auto-generated within your
                      pricing policy. Maximize conversion, protect margins.
                    </p>
                  </div>
                </div>

                <div className="py-6 border-b border-stone-300 grid grid-cols-12 gap-4" data-id="element-1368">
                  <div className="col-span-1" data-id="element-1369">
                    <span className="font-mono text-xs text-stone-400" data-id="element-1370">04</span>
                  </div>
                  <div className="col-span-4" data-id="element-1371">
                    <p className="font-medium text-stone-900" data-id="element-1372">
                      Proposal Generation
                    </p>
                  </div>
                  <div className="col-span-7" data-id="element-1373">
                    <p className="text-stone-600" data-id="element-1374">
                      Standardized, branded proposals exported in one click.
                      Ready for client presentation.
                    </p>
                  </div>
                </div>

                <div className="py-6 border-b border-stone-300 grid grid-cols-12 gap-4" data-id="element-1375">
                  <div className="col-span-1" data-id="element-1376">
                    <span className="font-mono text-xs text-stone-400" data-id="element-1377">05</span>
                  </div>
                  <div className="col-span-4" data-id="element-1378">
                    <p className="font-medium text-stone-900" data-id="element-1379">Policy Engine</p>
                  </div>
                  <div className="col-span-7" data-id="element-1380">
                    <p className="text-stone-600" data-id="element-1381">
                      Rate floors, blackout dates, concession limits—enforced
                      automatically across all quotes.
                    </p>
                  </div>
                </div>

                <div className="py-6 grid grid-cols-12 gap-4" data-id="element-1382">
                  <div className="col-span-1" data-id="element-1383">
                    <span className="font-mono text-xs text-stone-400" data-id="element-1384">06</span>
                  </div>
                  <div className="col-span-4" data-id="element-1385">
                    <p className="font-medium text-stone-900" data-id="element-1386">Audit Trail</p>
                  </div>
                  <div className="col-span-7" data-id="element-1387">
                    <p className="text-stone-600" data-id="element-1388">
                      Every quote, change, and approval tracked and reportable.
                      Complete visibility for revenue teams.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}